import React from 'react';
import { Link, Button } from '@mui/material';

export const FavoritesLink = () => {
  return (
    <Button component={Link} href="/favorites" sx={{ color: 'text.primary' }}>
      Favorites
    </Button>
  );
};
